import {
  type Options,
  type Schema,
  convertSchemaToHtml as base,
} from '@thebeyondgroup/shopify-rich-text-renderer';

const convertSchemaToHtml = (schema: Schema): string => {
  const options = {
    scoped: 'cur-space-y-4',
    classes: {
      h3: 'cur-text-h3 cur-tracking-h3 cur-leading-h3 cur-font-bold cur-font-heading', // h3 classes
      p: 'cur-font-normal cur-text-inherit cur-font-body', // paragraph classes
      ul: 'cur-list-disc cur-ml-4 cur-space-y-4', // unordered list classes
    },
  } satisfies Options;

  return base(schema, options);
};

export { convertSchemaToHtml };
